import { loadStripe } from "@stripe/stripe-js";
import isProduction from "Utils/isProduction";

export const stripePromise = isProduction
  ? loadStripe("pk_live_51PGPEkHEDOYkrooVACkvPra7Bk7DFhfk5BvCvJHZmlmKpWT3wXiPjykbtEPlZO2VGj8Ah602rx9beJjr0Faw5eEQ00v4TlCGCs")
  : loadStripe("pk_test_51PGPEkHEDOYkrooVwS84xSJ3Q05OstD0l1uOfcL7CMJ9WCpMVbnFuSQ76U13WB638n0l8yyGrktuxtStnF1gvqLs0048r2tuzS");
